"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../strings/ltrim.js");exports.toShopifyURL=function(t,r){return 0===t.indexOf("/")?"".concat(r).concat(e.default(t,["/"])):t};
//# sourceMappingURL=toShopifyURL.js.map
